import { useRouteState } from "hooks";

export default function usePath() {
  return useRouteState("path", {
    defaultValue: [],
    serialize: (value) => value.join("/"),
    deserialize: (str) => str.split("/").filter((s) => s),
  });
}
